import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Table from 'components/application/Table';

import CoshhRow from 'components/projectCoshh/components/CoshhRow';

export default function ProjectCoshhTable({
  coshhDocuments = [],
  onCoshhDocumentRowClick,
  onDeleteClick,
  onDownloadClick,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  return (
    <Table
      headers={
        <tr className='handshq__tr--grey tw-bg-grey-050'>
          <th className='tw-w-1/2 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('projects.coshh.coshhAssessment')}
          </th>
          <th className='tw-w-[30%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('projects.manufacturer')}
          </th>
          <th className='tw-w-[10%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.reference')}
          </th>
          <th className='tw-w-[10%] tw-text-right tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.actions')}
          </th>
        </tr>
      }
      rows={coshhDocuments.map((coshhDocument) => (
        <CoshhRow
          coshhDocument={coshhDocument}
          key={coshhDocument.id}
          onCoshhDocumentRowClick={onCoshhDocumentRowClick}
          onDeleteClick={onDeleteClick}
          onDownloadClick={onDownloadClick}
        />
      ))}
    />
  );
}

ProjectCoshhTable.propTypes = {
  coshhDocuments: PropTypes.array.isRequired,
  onCoshhDocumentRowClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
};
